import { useEffect, useRef } from 'react';

import { useEffectOnce } from 'pkg/hooks/component-lifecycle';

type Effect = () => void;

type AsyncEffect = () => Promise<void>;

export default function useComponentDidMount(
	onMount: Effect | AsyncEffect,
	onUnmount?: Effect
): void {
	useEffectOnce(() => {
		onMount();

		if (onUnmount) {
			return onUnmount;
		}
	});
}

// The callback is handed over, not called: useEffectOnce runs what it is given
// on mount and keeps the return value as the destructor.
export function useComponentWillUnmount(onUnmount?: Effect): void {
	useEffectOnce(() => onUnmount);
}

export function useComponentWillMount(onWillMount: Effect | AsyncEffect): void {
	const mounted = useRef<boolean>(false);

	if (!mounted.current) {
		onWillMount();
	}

	useEffect(() => {
		mounted.current = true;
	}, []);
}
